import React from "react";
import _ from "lodash";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import ListingFilterSectionComponent from "../ListingContent/ListingFilterSection/ListingFilterSectionComponent";

import CONFIG from "../../../utils/config";
import ErrorSection from "../../ErrorPage/ErrorSection";
import NotFoundComponent from "../NotFound/NotFoundComponent";
import { useSelector } from "react-redux";
import StripOffer from "../../Course/StripOffer";

const SORT_BY = [
  { value: 1, label: "A to Z" },
  { value: 2, label: "Z to A" },
];

function PartnerListSection({
  eventList,
  originalEventList,
  setEventList,
  setSelectedSort,
  isLoading,
  onSearchClicked,
}) {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const authBroker = useSelector((state) => state.auth.authBroker);

  // const onSearchClicked = (searchText) => {
  //   console.log("searchtext", searchText, originalEventList);
  //   setEventList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  //   if (searchText) {
  //     const searchStr = searchText.toLowerCase();
  //     setEventList(
  //       originalEventList.filter((item) => {
  //         const title = item.title.toLowerCase();
  //         const tags = item.tagsArray.map((t) => t.toLowerCase());
  //         if (title.includes(searchStr)) {
  //           return item;
  //         } else if (!_.isEmpty(tags)) {
  //           for (let t of tags) {
  //             if (t.includes(searchStr)) {
  //               return item;
  //             }
  //           }
  //         }
  //       })
  //     );
  //   } else if (searchText === "") {
  //     setEventList(originalEventList);
  //   }
  // };

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <div className="contsection">
        <nav>
          {false && (
            <h3 className="subs-course-title">Our Learning Partners</h3>
          )}
          {true && (
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Our{" "}
                {authBroker?.payload?.user?.config?.partner_menu_text !==
                  undefined &&
                !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
                  ? authBroker?.payload?.user?.config?.partner_menu_text
                  : "Learning Partners"}
              </button>
            </div>
          )}
        </nav>

        <div className="tab-content" id="nav-tabContent">
          <ListingFilterSectionComponent
            onSearchClicked={onSearchClicked}
            showSearch={true}
            showSort={true}
            showFilter={false}
            sortOption={SORT_BY}
            setSelectedSort={setSelectedSort}
            searchPlaceHolder={`Search for ${
              authBroker?.payload?.user?.config?.partner_menu_text !==
                undefined &&
              !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
                ? authBroker?.payload?.user?.config?.partner_menu_text
                : "Learning Partners.."
            }`}
            showCategories={false}
            entityType={"partners"}
          />
        </div>
        <div className="mb-2">
          <StripOffer isTerm={false} page={"partner"} />
        </div>
        <div className="">
          {!isLoading && eventList?.length > 0 && (
            <span>
              We found {eventList?.length}{" "}
              {authBroker?.payload?.user?.config?.partner_menu_text !==
                undefined &&
              !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
                ? authBroker?.payload?.user?.config?.partner_menu_text?.toLowerCase()
                : "learning partner"}
              {!authBroker?.payload?.user?.config?.partner_menu_text?.includes(
                "Acade"
              ) && eventList?.length > 1
                ? "s"
                : ""}{" "}
              for you
            </span>
          )}
          <div className="coursecard-row row">
            {eventList.length === 0 ? (
              <NotFoundComponent showMsg={true} />
            ) : (
              eventList.map((item, index) => {
                return (
                  <>
                    <ProductCardComponent
                      {...item}
                      key={`event-${index + 1}`}
                      lastKey={eventList.length === index + 1}
                      cardClassName="partnercard"
                    />
                  </>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerListSection;
